<template>
    <div class="w-full h-full flex flex-col">
        <div class="w-full flex justify-end">
            <base-button-affirmative @click="addClientPost">
                Add Post
            </base-button-affirmative>
        </div>
        <div class="flex flex-col w-full px-4">
            <ClientPost class="m-2" v-for="post in clientPosts" @refetch-clients="fetchNewClients" :client="client" :user-options="userOptions" :key="post.id" :post="post" />
        </div>
        
        <base-modal 
        :is-form-visible="addFormVisible" @close="closeClientPostForm"
            >
              <template v-slot:header>
                Add Post
              </template>
              <template v-slot:body>
                    <ClientPostForm add-or-edit="add" @add-post="createNewClientPost" :client="client" :user-options="userOptions" />
              </template>
        </base-modal>
    </div>
</template>

<script setup>
import { defineProps, ref, computed, defineEmits } from 'vue';
import ClientPost from './ClientPost.vue';
import ClientPostForm from './ClientPostForm.vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { createClientPost } from '@/services/ClientPost';

const props = defineProps(['client', 'userOptions'])
const emit = defineEmits(['refetchClients'])
const $toast = useToast() 
const store = useStore()
const addFormVisible = ref(false)

function addClientPost(){
    addFormVisible.value = true 
}

function closeClientPostForm(){
    addFormVisible.value = false
}

function fetchNewClients(){
    emit('refetchClients')
}

const clientPosts = computed(() => {
    return props.client.client_posts
})

async function createNewClientPost(clientPostData){
    const token = store.state.auth.token
    const result = await createClientPost(token, clientPostData)
    if(result.status == 201){
        $toast.open({
            message: 'Successfully created new post',
            type: 'success',
            duration: 3000
        })
        fetchNewClients()
        closeClientPostForm()
    } else {
        $toast.open({
            message: 'Error, could not create new post',
            type: 'error',
            duration: 3000
        })
    }
}


</script>